import React from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { useHistory } from 'react-router-dom'
import FramedIcon from 'redesign/components/atoms/FramedIcon'
import { PlaceholderIcon } from 'redesign/components/atoms/Icon'
import routes from 'services/RoutesProvider/routes'
import ContentCard from '../content-card'
import { TimelineItemContainer } from '../timeline-item/styles'
import type { TimelineVerifyIdentityProps } from './types'

const TimelineVerifyIdentity: React.FC<TimelineVerifyIdentityProps> = ({ tenantName, taskUuid }) => {
  const { t } = useFavurTranslation()
  const history = useHistory()

  return (
    <TimelineItemContainer data-testid="timeline-verify-identity">
      <ContentCard
        onClick={() => history.push(`${routes.securitySetup}?taskUuid=${taskUuid}`)}
        header={{
          icon: <FramedIcon icon={PlaceholderIcon} />,
          title: t('secureConnection.timeline.identificationCta'),
          titleTestId: 'timeline-verify-identity-title',
          subtitle: tenantName,
          subtitleTestId: 'timeline-verify-identity-subtitle',
          showChevron: true,
        }}
        hasBorder={false}
      />
    </TimelineItemContainer>
  )
}

export default TimelineVerifyIdentity
